import { Injectable, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ReplaySubject } from 'rxjs/internal/ReplaySubject';
import { Subject } from 'rxjs/internal/Subject';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/types/subject-type.enum.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
import * as ɵngcc0 from '@angular/core';
const SubjectType = {
    Subject: 0,
    BehaviorSubject: 1,
    ReplaySubject: 2,
};
SubjectType[SubjectType.Subject] = 'Subject';
SubjectType[SubjectType.BehaviorSubject] = 'BehaviorSubject';
SubjectType[SubjectType.ReplaySubject] = 'ReplaySubject';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/services/ngx-pub-sub.service.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxPubSubService {
    constructor() {
        this.eventObservableMapping = {};
    }
    /**
     * @param {?} eventName
     * @param {?=} data
     * @return {?}
     */
    publishEvent(eventName, data) {
        this.validateEventName(eventName);
        this.createSubjectIfNotExist(eventName);
        this.publishNext(eventName, SubjectType.Subject, data);
    }
    /**
     * @param {?} eventName
     * @param {?=} next
     * @param {?=} error
     * @param {?=} complete
     * @return {?}
     */
    subscribe(eventName, next, error, complete) {
        this.validateEventName(eventName);
        // subject will be created if the provided eventName is not registered
        this.createSubjectIfNotExist(eventName);
        return this.eventObservableMapping[eventName].ref.subscribe(next, error, complete);
    }
    /**
     * Use this method to get the Observable associated with the event.
     * Useful when you would like to apply additional rxjs operators like debounceTime
     * @param {?} eventName
     * @return {?}
     */
    getEventObservable(eventName) {
        this.validateEventName(eventName);
        // subject will be created if the provided eventName is not registered
        this.createSubjectIfNotExist(eventName);
        return this.eventObservableMapping[eventName].ref.asObservable();
    }
    /**
     * @param {?} name
     * @param {?} defaultValue
     * @return {?}
     */
    registerEventWithLastValue(name, defaultValue) {
        this.validateEventName(name);
        // type and name check
        this.checkEventType(name, SubjectType.BehaviorSubject, true);
        // create one
        this.eventObservableMapping[name] = {
            type: SubjectType.BehaviorSubject,
            ref: new BehaviorSubject(defaultValue)
        };
    }
    /**
     * @param {?} name
     * @param {?=} bufferSize
     * @param {?=} windowTime
     * @param {?=} scheduler
     * @return {?}
     */
    registerEventWithHistory(name, bufferSize, windowTime, scheduler) {
        this.validateEventName(name);
        // type and name check
        this.checkEventType(name, SubjectType.ReplaySubject, true);
        // create one
        this.eventObservableMapping[name] = {
            type: SubjectType.ReplaySubject,
            ref: new ReplaySubject(bufferSize, windowTime, scheduler)
        };
    }
    /**
     * @param {?} eventName
     * @param {?=} data
     * @return {?}
     */
    publishWithLast(eventName, data) {
        this.validateEventName(eventName);
        this.publishNext(eventName, SubjectType.BehaviorSubject, data);
    }
    /**
     * @param {?} eventName
     * @param {?=} data
     * @return {?}
     */
    publishWithHistory(eventName, data) {
        this.validateEventName(eventName);
        this.publishNext(eventName, SubjectType.ReplaySubject, data);
    }
    /**
     * @param {?} eventName
     * @return {?}
     */
    completeEvent(eventName) {
        this.validateEventName(eventName);
        if (!this.eventObservableMapping[eventName]) {
            throw Error('Event not created yet');
        }
        this.completeObservableAndDestroyMapping(eventName);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        for (const eventName in this.eventObservableMapping) {
            if (this.eventObservableMapping.hasOwnProperty(eventName)) {
                this.completeObservableAndDestroyMapping(eventName);
            }
        }
    }
    /**
     * @private
     * @param {?} eventName
     * @param {?=} type
     * @param {?=} data
     * @return {?}
     */
    publishNext(eventName, type = SubjectType.Subject, data) {
        this.checkEventType(eventName, type);
        this.eventObservableMapping[eventName].ref.next(data);
    }
    /**
     * @private
     * @param {?} eventName
     * @param {?=} type
     * @param {?=} shouldNotExist
     * @return {?}
     */
    checkEventType(eventName, type = SubjectType.Subject, shouldNotExist = false) {
        /** @type {?} */
        const object = this.eventObservableMapping[eventName];
        /** @type {?} */
        let errorMessage;
        if (!object && shouldNotExist) {
            return;
        }
        if (!object) {
            errorMessage = `Event doesn't exist of type: ${SubjectType[type]} or it has been completed`;
        }
        else if (object.type !== type) {
            errorMessage = `Event exists with other type: ${SubjectType[object.type]}. Expected type: ${SubjectType[type]}`;
        }
        if (shouldNotExist && object.type === type) {
            errorMessage = `Event already registerd with the same type. Don't register a second time`;
        }
        if (errorMessage) {
            throw Error(`Error (${eventName}): ${errorMessage}`);
        }
    }
    /**
     * @private
     * @param {?} eventName
     * @return {?}
     */
    createSubjectIfNotExist(eventName) {
        /** @type {?} */
        const object = this.eventObservableMapping[eventName];
        if (object) {
            return;
        }
        this.eventObservableMapping[eventName] = {
            type: SubjectType.Subject,
            ref: new Subject()
        };
    }
    /**
     * @private
     * @param {?} eventName
     * @return {?}
     */
    validateEventName(eventName) {
        if (!eventName) {
            throw Error('Event name not provided');
        }
    }
    /**
     * @private
     * @param {?} eventName
     * @return {?}
     */
    completeObservableAndDestroyMapping(eventName) {
        this.eventObservableMapping[eventName].ref.complete();
        delete this.eventObservableMapping[eventName];
    }
}
NgxPubSubService.ɵfac = function NgxPubSubService_Factory(t) { return new (t || NgxPubSubService)(); };
NgxPubSubService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NgxPubSubService, factory: NgxPubSubService.ɵfac });
/** @nocollapse */
NgxPubSubService.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxPubSubService, [{
        type: Injectable
    }], function () { return []; }, null); })();
if (false) {
    /**
     * @type {?}
     * @private
     */
    NgxPubSubService.prototype.eventObservableMapping;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-pub-sub.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxPubSubModule {
}
NgxPubSubModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NgxPubSubModule });
NgxPubSubModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function NgxPubSubModule_Factory(t) { return new (t || NgxPubSubModule)(); }, providers: [NgxPubSubService], imports: [[CommonModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxPubSubModule, { imports: function () { return [CommonModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NgxPubSubModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                providers: [NgxPubSubService]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: index.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: pscoped-ngx-pub-sub.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxPubSubModule, NgxPubSubService };

//# sourceMappingURL=pscoped-ngx-pub-sub.js.map